<p class="welcome">Welcome to the MSAL.js Angular Quickstart!</p>
<p>This sample demonstrates how to configure MSAL Angular to login, logout, protect a route, and acquire an access token for a protected resource such as the Microsoft Graph.</p>
